module.exports = __webpack_public_path__ + "img/xmas-red.536acfb.jpg";